import React  from 'react'
const Spinner =()=> {
    return (
      <div className='text-center'>
        <div class="spinner-grow text-light fs-1" role="status">
        <span class="visually-hidden text-light fs-1">Loading...</span>
      </div>
      </div>
    )
  
}
export default Spinner